import React from 'react'
import {Link} from 'react-router-dom';
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon, UserGroupIcon,AcademicCapIcon } from '@heroicons/react/outline'
import { Fragment } from 'react'
import Footer from '../Footer';
import AdminMain from './AdminMain';



const user = {
     name: 'Tom Cook',
     email: 'tom@example.com',
   }
   const userNavigation = [
     { name: 'Reset Password', href: '/Student-Dashboard/ResetPassword' },
     { name: 'Logout', href: '/' },
   ]
   
   function classNames(...classes) {
     return classes.filter(Boolean).join(' ')
   }
   

export default function OfficeNavbar() {
  return (
     <>
     <div className="min-h-full">
       <Disclosure as="nav" className="bg-veryDarkBlue">
         {({ open }) => (
           <>
             <div className="max-w-7xl mx-auto py-6 px-4">
               <div className="flex items-center justify-between h-16">
                 <div className="flex items-center">
                   <div className="flex-shrink-0">

                   <Link className="flex flex-row justify-center items-center " to="/">
                        <img
                             className="w-auto rounded-lg h-16 md:h-12"
                             src="./ashok-logo.png"
                             alt=""
                        />
                        <div className="flex flex-col  ml-3 md:ml-2 md:mt-2">
                             <span className="text-brightRed text-md font-bold">National Scholarship Portal</span>
                             <span className="text-gray-500 text-xs">Ministry of Electronics & Information Technolgy ,</span>
                             <span className="text-gray-500 text-xs">Government of India</span>
                        </div>
                   </Link>

                   </div>
                 </div>
                 <div className="hidden md:block">
                   <div className="ml-4 flex items-center md:ml-6">
                     <button
                       type="button"
                       className="bg-gray-800 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                     >
                       <span className="sr-only">View notifications</span>
                       <BellIcon className="h-6 w-6" aria-hidden="true" />
                     </button>

                     {/* Profile dropdown */}
                     <Menu as="div" className="ml-3 relative">
                       <div>
                         <Menu.Button className="max-w-xs h-8 w-8 bg-gray-800 rounded-full flex items-center justify-center text-sm">
                           <span className="sr-only">Open user menu</span>
                              <UserGroupIcon className="h-6  text-gray-400 hover:text-white w-6" aria-hidden="true"/>
                         </Menu.Button>
                       </div>
                       <Transition
                         as={Fragment}
                         enter="transition ease-out duration-100"
                         enterFrom="transform opacity-0 scale-95"
                         enterTo="transform opacity-100 scale-100"
                         leave="transition ease-in duration-75"
                         leaveFrom="transform opacity-100 scale-100"
                         leaveTo="transform opacity-0 scale-95"
                       >
                         <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                           {userNavigation.map((item) => (
                             <Menu.Item key={item.name}>
                               {({ active }) => (
                                 <a
                                   href={item.href}
                                   className={classNames(
                                     active ? 'bg-gray-100' : '',
                                     'block px-4 py-2 text-sm text-gray-700'
                                   )}
                                 >
                                   {item.name}
                                 </a>
                               )}
                             </Menu.Item>
                           ))}
                         </Menu.Items>
                       </Transition>
                     </Menu>
                   </div>
                 </div>
                 <div className="-mr-2 flex md:hidden">
                   {/* Mobile menu button */}
                   <Disclosure.Button className="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                     <span className="sr-only">Open main menu</span>
                     {open ? (
                       <XIcon className="block h-6 w-6" aria-hidden="true" />
                     ) : (
                       <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                     )}
                   </Disclosure.Button>
                 </div>
               </div>
             </div>

             <Disclosure.Panel className="md:hidden">
               <div className="pt-4 pb-3 border-t border-gray-700">
                 <div className="flex items-center px-5">
                   <div className="flex-shrink-0">
                     <img className="h-10 w-10 rounded-full" src={user.imageUrl} alt="" />
                   </div>
                   <div className="ml-3">
                     <div className="text-base font-medium leading-none text-white">{user.name}</div>
                     <div className="text-sm font-medium leading-none text-gray-400">{user.email}</div>
                   </div>
                   <button
                     type="button"
                     className="ml-auto bg-gray-800 flex-shrink-0 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                   >
                     <span className="sr-only">View notifications</span>
                     <BellIcon className="h-6 w-6" aria-hidden="true" />
                   </button>
                 </div>
                 <div className="mt-3 px-2 space-y-1">
                   {userNavigation.map((item) => (
                     <Disclosure.Button
                       key={item.name}
                       as="a"
                       href={item.href}
                       className="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700"
                     >
                       {item.name}
                     </Disclosure.Button>
                   ))}
                 </div>
               </div>
             </Disclosure.Panel>
           </>
         )}
       </Disclosure>
     </div>


     {/* Hero Section */}

     <AdminMain/>
     <Footer/>
   </>

  )
}
